import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_104: FaireProductEntity = {
  token: "catalog_prod_prod-104",
  type: "product",
  name: "Accent Piece - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop",
  priceDollars: 109.91,
  msrpDollars: 274.77,
  sku: "CA0104",
  caseSize: 2,
  material: "Linen",
  collectionToken: "col_camp",
  categoryTokens: ["catalog_cat_cats"],
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 187,
  description: "Beautiful Camp! piece perfect for any home.",
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
